import './share-on.scss';
import Tooltip from 'bootstrap-italia/src/js/plugins/tooltip';
import { Translations } from '../utils';

/**
 * version    1.3
 * class      ShareOn
 * classdesc  Component that manage the share on social
 */
export class ShareOn {
  constructor() {
    this.components = document.querySelectorAll('.share-on');
    this.pageUrl = encodeURIComponent(window.location.href);
    this.pageTitle = encodeURIComponent(document.title);

    this.init();
  }

  init() {
    if (!this.components.length) return;

    this.components.forEach((component) => {
      const btn = component.querySelector('.share-toggle');
      const slider = component.querySelector('.share-slider');
      const focusable = slider ? slider.querySelectorAll('a, button') : null;

      if (!btn || !slider) return;

      this.setupShareLinks(component);
      this.setupCopy(component);

      /**
       * Toggle slider
       */
      btn.addEventListener('click', (e) => {
        e.stopPropagation();

        const isOpen = btn.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(isOpen));

        if (isOpen) {
          if (focusable && focusable[0]) focusable[0].focus();
        }
      });

      /**
       * Click fuori dal componente per chiudere lo slider
       */
      document.addEventListener('click', (event) => {
        if (!component.contains(event.target)) {
          this.close(btn);
        }
      });

      /**
       * ESC per chiudere lo slider
       */
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          if (btn.classList.contains('is-open')) {
            this.close(btn);
            btn.focus(); // ritorna focus al bottone
          }
        }
      });
    });
  }

  /**
   * Setup link social
   */
  setupShareLinks(component) {
    const fb = component.querySelector('.share-fb');
    const linkedin = component.querySelector('.share-linkedin');
    const x = component.querySelector('.share-x');
    const mail = component.querySelector('.share-mail');

    if (fb) {
      fb.href = `https://www.facebook.com/sharer/sharer.php?u=${this.pageUrl}`;
    }

    if (linkedin) {
      linkedin.href = `https://www.linkedin.com/sharing/share-offsite/?url=${this.pageUrl}`;
    }

    if (x) {
      x.href = `https://twitter.com/intent/tweet?url=${this.pageUrl}&text=${this.pageTitle}`;
    }

    if (mail) {
      mail.href = `mailto:?subject=${this.pageTitle}&body=${this.pageUrl}`;
    }
  }

  /**
   * Copy link negli appunti
   */
  setupCopy(component) {
    const copyBtn = component.querySelector('.copy-link');
    // eslint-disable-next-line no-unused-vars
    const label = copyBtn && copyBtn.querySelector('.copy-label');

    if (!copyBtn) return;

    const tooltip = new Tooltip(copyBtn, {
      trigger: 'manual',
      placement: 'top',
      title: Translations.getLabel('SHARE_ON_LINK_COPIED', {}, 'Link copiato!'),
    });

    const showTooltip = () => {
      setTimeout(() => {
        copyBtn.focus();
        tooltip.show();

        setTimeout(() => {
          tooltip.hide();
        }, 2500);
      }, 50);
    };

    const copyFallback = (text) => {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        const successful = document.execCommand('copy');
        document.body.removeChild(textarea);
        return successful;
      } catch (err) {
        document.body.removeChild(textarea);
        return false;
      }
    };

    const copyAction = async () => {
      const url = window.location.href;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(url);
          showTooltip();
        } catch (err) {
          if (copyFallback(url)) {
            showTooltip();
          }
        }
      } else if (copyFallback(url)) {
        showTooltip();
      }
    };

    copyBtn.addEventListener('click', copyAction);
  }

  close(btn) {
    btn.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
  }
}
